import { isEmpty } from 'lodash';
import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';
import useSetExport from '@components/export/useSetExport';
import { metricFilterSelector } from '@store/trends/base/selectors';
import { comparisonIntervalSelector } from '@store/summaryContainer/comparison/selectors';
import { getFirstAppliedFilter, intervalSelector } from '@store/common/selectors';
import { dodAtom } from '@components/metrics-panel-hz/atoms';

function useSetExportBase() {
  const appliedFilter = useSelector(getFirstAppliedFilter);
  const interval = useSelector(intervalSelector);
  const compareInterval = useSelector(comparisonIntervalSelector);
  const dodEnabled = useAtomValue(dodAtom) && !isEmpty(compareInterval);
  const metricFilter = useSelector(metricFilterSelector);

  useSetExport({
    pageKey: 'trends',
    sectionKey: 'base',
    widgetKey: 'base',
    widgetInfo: { title: '' },
    data: {
      appliedFilter,
      interval,
      compareInterval: dodEnabled ? compareInterval : null,
      metricFilter,
    },
    headers: [],
  });
}

export default useSetExportBase;
